import { useEffect, useState } from "react";
import { SiteNav } from "../components/site/SiteNav";
import { Hero } from "../components/site/Hero";
import { Activities } from "../components/site/Activities";
import { NAV } from "../components/site/siteData";
import {
  Why, About, Gallery, Media, Careers, Achievements, Contact, Footer,
} from "../components/site/Sections";

export default function Home() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); });
      },
      { rootMargin: "-40% 0px -55% 0px" },
    );
    NAV.forEach((n) => {
      const el = document.getElementById(n.id);
      if (el) obs.observe(el);
    });
    const onScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 4) setActive("contact");
    };
    window.addEventListener("scroll", onScroll);
    return () => { obs.disconnect(); window.removeEventListener("scroll", onScroll); };
  }, []);

  return (
    <div className="bg-[#EEF4FF] min-h-screen scroll-smooth" data-testid="home-page">
      <SiteNav active={active} />
      <Hero />
      <Why />
      <Activities />
      <About />
      <Gallery />
      <Media />
      <Careers />
      <Achievements />
      <Contact />
      <Footer />
    </div>
  );
}
